import React, { useEffect, useMemo, useState } from 'react';

import { Alert, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Link, withRouter } from 'react-router-dom';
// import { AvField, AvForm } from 'availity-reactstrap-validation';

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/logo.svg";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { loginErrorState } from '../../state/ErrorState';
import { loginRequest, verifyLoginRequest } from '../../api/controller/AuthController'
import { passwordResetHashState, otpReferenceState } from '../../api/state/AuthState';
import { themeTypeState } from '../../state/GlobalState';

function safeDecodeErrorParam(value) {
    try {
        return decodeURIComponent(String(value).replace(/\+/g, ' '));
    } catch (e) {
        return value;
    }
}

const Login = ({ history, location, handleAuthResponse }) =>  {
    const [error, setError] = useRecoilState(loginErrorState)
    const [submitDisabled, setSubmitDisabled] = useState(false)
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('authUser')))
    const [rememberMe, setRememberMe] = useState(false)
    const setPasswordResetHash = useSetRecoilState(passwordResetHashState)
    const [otpReference, setOtpReference] = useRecoilState(otpReferenceState)
    const themeType = useRecoilValue(themeTypeState)
    const [form, setForm] = useState({
        email: '',
        password: '',
        OTP: '',
    })

    const entraLoginUrl = useMemo(() => {
        const base = (process.env.REACT_APP_API_URL || '').replace(/\/?$/, '/');
        return `${base}entra/login`;
    }, []);

    // OAuth / Entra error callback (EntraController redirects to /login?error=…)
    useEffect(() => {
        const params = new URLSearchParams(location?.search || '');
        const err = params.get('error');
        if (err == null || err === '') {
            return;
        }
        setError(safeDecodeErrorParam(err));
        history.replace({ pathname: location.pathname, search: '' });
    }, [location?.search, location?.pathname, history, setError]);

    // handleValidSubmit
    const handleValidSubmit = async (event) => {
        event.preventDefault()
        setSubmitDisabled(true)
        let response = null
        if(otpReference === null){
            response = await loginRequest({email: user ? user.email : form.email, password: form.password})
        } else {
            response = await verifyLoginRequest({ reference: otpReference, otp: form.OTP })
        }
        
        if(response.decodedToken){
            handleAuthResponse(response, response.encodedToken, rememberMe, true)
        } else if(response.scp){
            localStorage.removeItem('authToken')
            setPasswordResetHash(response.hash)
            history.push('/change-password');
        } else if(response.otp){
            localStorage.removeItem('authToken')
            setOtpReference(response.Reference)
            setSubmitDisabled(false)
        } else if (response.message){
            setError(response.message)
            setSubmitDisabled(false)
        } else {
            setError(response.Message)
            setSubmitDisabled(false)
        }
    }

    return (
        <React.Fragment>
            {/* <div className="home-btn d-none d-sm-block">
                <Link to="/" className="text-dark"><i className="bx bx-home h2"></i></Link>
            </div> */}
            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6}>
                            <Card className="overflow-hidden">
                                <div className="bg-primary bg-soft">
                                    <Row>
                                        <Col className="col-7">
                                            <div className={"p-4 " + (themeType === 'dark' ? 'text-white' : 'text-primary')}>
                                                <h5 className={(themeType === 'dark' ? 'text-white' : 'text-primary')}>Welcome Back !</h5>
                                                <p>{user ? "Enter your password to unlock!" : "Sign in to continue."}</p>
                                            </div>
                                        </Col>
                                        <Col className="col-5 align-self-end">
                                            <img src={profile} alt="" className="img-fluid" />
                                        </Col>
                                    </Row>
                                </div>
                                <CardBody className="pt-0">
                                    <div>
                                        <Link to="/">
                                            <div className="avatar-md profile-user-wid mb-4">
                                                <span className="avatar-title rounded-circle bg-light">
                                                    <img src={logo} alt="" className="rounded-circle" height="34" />
                                                </span>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="p-2">

                                        <Form className="form-horizontal" onSubmit={handleValidSubmit}>

                                            {error ? <Alert color="danger">{error}</Alert> : null}
                                            {otpReference === null ? (
                                                <>
                                                    {user ? (
                                                        <div className="user-thumb text-center mb-4">
                                                            <img src={user.avatar} className="rounded-circle img-thumbnail avatar-md" alt="thumbnail"/>
                                                            <h5 className={"font-size-15 mt-3 " + (themeType === 'dark' ? 'text-white' : '')}>{user.name}</h5>
                                                        </div>
                                                    ) : (
                                                        <FormGroup>
                                                            <Label>Email</Label>
                                                            <Input value={form.email} onChange={(e)=>setForm({...form, email: e.target.value})} name="email" label="Email" className="form-control" placeholder="Enter email" type="email" required />
                                                        </FormGroup>
                                                    )}

                                                    <FormGroup>
                                                        <Label>Password</Label>
                                                        <Input value={form.password} onChange={(e)=>setForm({...form, password: e.target.value})} name="password" label="Password" type="password" required placeholder="Enter Password" />
                                                    </FormGroup>
                                                    {!user ? (
                                                        <div className="custom-control custom-checkbox" onClick={()=>setRememberMe(!rememberMe)}>
                                                            <Input type="checkbox" className="custom-control-input" onChange={()=>false} checked={rememberMe} />
                                                            <Label className="custom-control-label" htmlFor="customControlInline">  &nbsp;Remember me</Label>
                                                        </div>
                                                    ) : null}
                                                </>
                                            ) : (
                                                <FormGroup>
                                                    <Label>OTP</Label>
                                                    <Input value={form.OTP} onChange={(e)=>setForm({...form, OTP: e.target.value})} name="OTP" label="We sent an OTP via text" className="form-control" placeholder="Enter OTP" type="number" required />
                                                </FormGroup>
                                            )}
                                            
                                            

                                            <div className="mt-4">
                                                <button disabled={submitDisabled} className="btn btn-primary btn-block waves-effect waves-light w-100" type="submit">{otpReference === null ? user ? "Unlock" : "Login" : "Verify"}</button>
                                            </div>

                                            {otpReference === null && !user ? (
                                                <div className="mt-3">
                                                    <div className="text-center my-2">
                                                        <span className="text-muted" style={{ fontSize: '0.8rem' }}>or</span>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        disabled={submitDisabled}
                                                        className="btn w-100 d-inline-flex align-items-center justify-content-center"
                                                        style={{
                                                            minHeight: '44px',
                                                            backgroundColor: '#F3F3F3',
                                                            color: '#5E5E5E',
                                                            border: '1px solid #8C8C8C',
                                                            fontSize: '15px',
                                                            fontWeight: 600,
                                                            lineHeight: 1.25,
                                                            padding: '0 12px',
                                                            gap: '10px',
                                                        }}
                                                        onClick={() => { window.location.assign(entraLoginUrl); }}
                                                        aria-label="Sign in with Microsoft"
                                                    >
                                                        <svg
                                                            width="23"
                                                            height="23"
                                                            viewBox="0 0 23 23"
                                                            aria-hidden="true"
                                                            className="flex-shrink-0"
                                                            style={{ display: 'block' }}
                                                        >
                                                            <path fill="#F25022" d="M0 0h11v11H0z" />
                                                            <path fill="#7FBA00" d="M12 0h11v11H12z" />
                                                            <path fill="#00A4EF" d="M0 12h11v11H0z" />
                                                            <path fill="#FFB900" d="M12 12h11v11H12z" />
                                                        </svg>
                                                        <span style={{ color: '#5E5E5E' }}>Sign in with Microsoft</span>
                                                    </button>
                                                </div>
                                            ) : null}

                                            <div className="mt-4 text-center">
                                                {otpReference === null ? <Link to="/forgot-password" className={(themeType === 'dark' ? 'text-white' : 'text-muted')}><i className="mdi mdi-lock mr-1"></i> Forgot your password?</Link>
                                                 : <p>Go back to{" "}<span style={{cursor: "pointer"}} className={"font-weight-medium " + (themeType === 'dark' ? 'text-white' : 'text-primary')} onClick={()=>{localStorage.removeItem('authUser');setUser(null);setOtpReference(null)}}>Login</span>{" "}</p> }
                                                
                                            </div>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>
                            {user ? (
                                <div className="mt-5 text-center">
                                    <p className={(themeType === 'dark' ? 'text-white' : '')} >Not you? return to <Link onClick={()=>{localStorage.removeItem('authUser');setUser(null)}} to="/" className={"font-weight-medium " + (themeType === 'dark' ? 'text-info' : 'text-primary')}> Sign In </Link> </p>
                                </div>
                            ) : null}
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default withRouter(Login);
